import React from "react";

export const Logo = ({ className = "", title }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <svg
      width="34"
      height="34"
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      className="shrink-0"
    >
      <rect width="64" height="64" rx="12" fill="hsl(var(--deep-blue))" />
      <rect x="16" y="12" width="32" height="40" rx="4" fill="hsl(36 33% 98%)" />
      <rect x="16" y="24" width="32" height="4" fill="hsl(var(--terracotta))" />
      <rect x="16" y="36" width="32" height="4" fill="hsl(var(--mineral-gray))" />
      <circle cx="32" cy="46" r="3.5" fill="hsl(var(--deep-blue))" />
      <path
        d="M23 14v7h7"
        fill="none"
        stroke="hsl(var(--deep-blue))"
        strokeWidth="3"
        strokeLinecap="square"
      />
    </svg>
    <span className="flex flex-col leading-none">
      <span className="font-display text-[19px] font-semibold tracking-tight text-[hsl(var(--deep-blue))]">
        Litiosur
      </span>
      <span className="font-data mt-1 text-[9px] uppercase tracking-[0.2em] text-[hsl(var(--ink-3))]">
        {title}
      </span>
    </span>
  </span>
);

export default Logo;
